module.exports = __webpack_public_path__ + "static/media/team1.3e7d0fdf.svg";